/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const submitCheckoutRequestImagesMax = 10;

export const submitCheckoutRequestTextsMax = 10;

export const SubmitCheckoutRequest = zod
	.object({
		'images[]': zod
			.array(zod.instanceof(File))
			.max(submitCheckoutRequestImagesMax)
			.optional()
			.describe('Array of image files to be moderated'),
		'metadata': zod.looseObject({}).optional().describe('Additional metadata'),
		'texts[]': zod
			.array(zod.instanceof(File))
			.max(submitCheckoutRequestTextsMax)
			.optional()
			.describe('Array of text content to be moderated')
	})
	.describe('Multipart form data for content submission');

export type SubmitCheckoutRequest = zod.input<typeof SubmitCheckoutRequest>;
export type SubmitCheckoutRequestOutput = zod.output<typeof SubmitCheckoutRequest>;
